import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import {
  GET_MESSAGE_CORRESPONDENTS,
  GET_MESSAGE_WITH,
  GET_UNREAD_MESSAGES,
} from '_api/queries/message';
import { Message, MessagePayload } from '_api/types';

export const CREATE_MESSAGE = 'create-message';

export const useCreateMessage = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Message, MessagePayload>(
    () => '/message/create',
    'post',
    {},
    {
      mutationKey: [CREATE_MESSAGE],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_MESSAGE_CORRESPONDENTS] });
        queryClient.invalidateQueries({ queryKey: [GET_UNREAD_MESSAGES] });
        queryClient.invalidateQueries({ queryKey: [GET_MESSAGE_WITH] });
      },
    },
    (body: MessagePayload) => JSON.stringify(body),
  );
};
